<template>
  <section class="app-main">
    <transition
    @enter="onEnter"
    @leave="onLeave"
    name="fade-transform" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <!-- <img style="display: flex; width: 320px;" :src="boss"/> -->
      <router-view :nextBranch="nextBranch" :tkitchenSocket="tkitchenSocket"></router-view>
    </transition>
    <div :class="bossLoading ? 'visible' : ''" class="loadingOverlay">
      <img style="display: flex; position: relative; height: 50px;" :src="boss"/>
    </div>
  </section>
</template>

<script>
/*
02/07/2022 proradar - Take a look at this website to call events for transitions
https://vuejs.org/guide/built-ins/transition.html#javascript-hooks
*/

import boss from '../../../../assets/sirim-blue.jpg'
export default {
  name: 'AppMain',
  data() {
    return {
      boss,
      bossLoading: false
    }
  },
  props: {
    nextBranch: {
      type: Function
    },
    tkitchenSocket: {
      type: Object
    },
  },
  methods: {
    onEnter() {
      this.bossLoading = false
    },
    onLeave() {
      this.bossLoading = true
    }
  },
  mounted() {
    // console.log("appmain")
    // this.nextBranch()
  },
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>

<style lang="scss">
.loadingOverlay {
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  justify-content: center;
  align-items: center;
  transition: ease 0.2s;
  // background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
}
.loadingOverlay.visible {
  display: flex;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/layout/components/AppMain.vue